// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.22585ca06',
  revision: '22585ca06',
  branch: 'develop',
  date: 'Wed, 23 Sep 2026 15:49:49 GMT'
};